import { defineAsyncComponent } from 'vue'
export default {
  basic: defineAsyncComponent(() => import("/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/layouts/basic.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/layouts/default.vue").then(m => m.default || m))
}